import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "spread",
  "use": "spread-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"spread\"><defs><style></style></defs><path d=\"M500.364 758.69L86.109 544.583l20.946-39.564 393.309 202.473 393.309-202.473 20.945 39.564z\" /><path d=\"M512 572.51L97.745 358.4l20.946-39.564L512 521.31l393.31-202.473 20.945 39.564z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol